import { render, staticRenderFns } from "./DragAndDrop.vue?vue&type=template&id=3d668728&scoped=true&"
import script from "./DragAndDrop.vue?vue&type=script&lang=js&"
export * from "./DragAndDrop.vue?vue&type=script&lang=js&"
import style0 from "./DragAndDrop.vue?vue&type=style&index=0&id=3d668728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d668728",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
